import React, { PropsWithChildren, ReactElement, ReactNode } from "react";
import { ChevronRightIcon } from "@spoctech/icons";
import {
  breadcrumbsRootClasses,
  breadcrumbsListItemClasses,
  breadcrumbsSeparatorClasses,
  BreadcrumbsVariants,
} from "./Breadcrumbs.style";

type BreadcrumbsProps = BreadcrumbsVariants & {
  separator?: ReactNode | ReactElement | string;
  className?: string;
};

function Breadcrumbs(props: PropsWithChildren<BreadcrumbsProps>) {
  const { children, separator, size, className } = props;

  const ChildrenElements = React.Children.toArray(children);

  const mappedTabChildren = ChildrenElements.map((child, idx) => {
    return (
      <li key={idx} className={breadcrumbsListItemClasses({ size })}>
        {child}
        {idx + 1 !== ChildrenElements?.length && (
          <span className={breadcrumbsSeparatorClasses({ size: size })}>
            {separator || <ChevronRightIcon />}
          </span>
        )}
      </li>
    );
  });

  return (
    <ol
      className={breadcrumbsRootClasses({
        size,
        class: className,
      })}
    >
      {mappedTabChildren}
    </ol>
  );
}

export default Breadcrumbs;
